<template>
  <!--
    O CARREGAMENTO (pedido do autor, 03/09: esquecemos dele). Era um gradiente azul-claro com uma
    vara de CSS quebrada e cinco 🐟 de emoji. Agora é o mar do jogo com A VIGIA DO BARQUINHO — o
    mesmo do palco de Pescar (D4: um primitivo, vários lugares) — e a mensagem num bilhete de
    papel. Esperar já é olhar o jogo.
  -->
  <div class="carregando">
    <FishingCharacter class="carregando__vigia" />

    <div class="carregando__bilhete">
      <p class="carregando__mensagem">{{ message }}<span class="carregando__pontos" aria-hidden="true"><span>.</span><span>.</span><span>.</span></span></p>
    </div>

    <div v-if="showConfirm" class="carregando__pronto">
      <p class="carregando__mensagem">{{ confirmMessage }}</p>
      <FishButton variante="primario" som="recompensa" @click="$emit('continue')">
        Começar!
      </FishButton>
    </div>
  </div>
</template>

<script>
import FishingCharacter from '@/shared/fishing/FishingCharacter.vue';
import { FishButton } from '@/shared/ui';

export default {
  name: 'LoadingScreen',
  components: { FishingCharacter, FishButton },
  props: {
    message: {
      type: String,
      default: 'Preparando sua vara de pesca'
    },
    showConfirm: {
      type: Boolean,
      default: false
    },
    confirmMessage: {
      type: String,
      default: 'Seu equipamento está pronto!'
    }
  },
  emits: ['continue'],
}
</script>

<style scoped>
.carregando {
  position: fixed;
  inset: 0;
  background: linear-gradient(to bottom, var(--agua-rasa, #2e6b8a), var(--agua-abissal));
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--e-4);
  z-index: 200;
}

.carregando__bilhete {
  border: var(--moldura-borda) solid transparent;
  border-image: url('/ui/frame-panel.png') var(--moldura-fatia) / var(--moldura-borda) repeat;
  background: var(--papel);
  background-clip: padding-box;
  image-rendering: pixelated;
  padding: var(--e-2) var(--e-4);
}

.carregando__mensagem {
  margin: 0;
  font-family: var(--fonte-display);
  font-size: var(--f-2);
  color: var(--tinta);
  text-align: center;
}

/* Os três pontos respiram em sequência — a única animação além do barquinho (D0). */
.carregando__pontos span {
  animation: carregando-ponto 1.4s var(--curva-suave) infinite;
}

.carregando__pontos span:nth-child(2) {
  animation-delay: 0.2s;
}

.carregando__pontos span:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes carregando-ponto {
  0%, 60%, 100% { opacity: 0.25; }
  30% { opacity: 1; }
}

.carregando__pronto {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--e-3);
}

.carregando__pronto .carregando__mensagem {
  color: var(--papel-luz);
}

@media (prefers-reduced-motion: reduce) {
  .carregando__pontos span {
    animation: none;
  }
}
</style>
